import {
  REQUEST_NEW_ALBUMS,
  RECEIVE_NEW_ALBUMS,
  INVALIDATE_NEW_ALBUMS
} from '../actions/HomeActions';

function posts(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) {
  switch (action.type) {
  case REQUEST_NEW_ALBUMS: {
    return Object.assign({}, state, {
      isFetching: true,
      didInvalidate: false
    });
  }
  case RECEIVE_NEW_ALBUMS: {
    return Object.assign({}, state, {
      isFetching: false,
      didInvalidate: false,
      items: action.posts,
      lastUpdated: action.receivedAt
    });
  }
  case INVALIDATE_NEW_ALBUMS: {
    return Object.assign({}, state, {
      isFetching: false,
      didInvalidate: false,
      items: []
    });
  }
  default:
    return state;
  }
}

function NewAlbumsReducer(state = {}, action) {
  switch (action.type) {
  case INVALIDATE_NEW_ALBUMS:
  case REQUEST_NEW_ALBUMS:
  case RECEIVE_NEW_ALBUMS: {
    return Object.assign({}, state, posts(state, action));
  }
  default: {
    return state;
  }
  }
}

export {
  NewAlbumsReducer
};


// WEBPACK FOOTER //
// ./src/reducers/HomeReducer.js